// This file is generated by scripts/sync-site-content.mjs
const siteContent = {
  "branding": {
    "eyebrow": "Portfolio",
    "name": "Eugen Maksymenko",
    "role": "Software Engineer"
  },
  "navigation": [
    {
      "title": "Home",
      "link": "/"
    },
    {
      "title": "CV",
      "link": "/cv"
    },
    {
      "title": "Blog",
      "link": "/blog"
    }
  ],
  "avatar": {
    "src": "/AvatarImages/EugenMaksymenko.jpeg",
    "alt": "Portrait of Eugen Maksymenko"
  },
  "home": {
    "eyebrow": "Software Engineer",
    "headline": "Eugen Maksymenko",
    "introParagraph": "I am a Software Engineer with a strong open-source background, experienced in Linux systems, CI/CD automation, and full-stack development. Contributor to projects at SUSE and working remotely in a globally distributed engineering team.",
    "secondaryParagraph": "Outside work, I build applications, self-host services on my own Linux infrastructure, and keep learning new tools by shipping real projects."
  },
  "skills": {
    "title": "Skills",
    "description": "Grouped overview of the technologies and practices listed in my CV.",
    "groups": [
      {
        "title": "Platform & Cloud",
        "skills": [
          {
            "icon": "linux",
            "name": "Linux"
          },
          {
            "icon": "aws",
            "name": "AWS"
          },
          {
            "icon": "azure",
            "name": "Azure"
          },
          {
            "icon": "podman",
            "name": "Podman"
          },
          {
            "icon": "docker",
            "name": "Docker"
          },
          {
            "icon": "kubernetes",
            "name": "Kubernetes"
          },
          {
            "icon": "helm",
            "name": "Helm"
          },
          {
            "icon": "terraform",
            "name": "Terraform"
          },
          {
            "icon": "ansible",
            "name": "Ansible"
          }
        ]
      },
      {
        "title": "Automation & Observability",
        "skills": [
          {
            "icon": "cicd",
            "name": "CI/CD"
          },
          {
            "icon": "github_actions",
            "name": "GitHub Actions"
          },
          {
            "icon": "gitlab",
            "name": "GitLab"
          },
          {
            "icon": "git",
            "name": "Git"
          },
          {
            "icon": "prometheus",
            "name": "Prometheus"
          },
          {
            "icon": "grafana",
            "name": "Grafana"
          }
        ]
      },
      {
        "title": "Languages & Data",
        "skills": [
          {
            "icon": "bash",
            "name": "Bash"
          },
          {
            "icon": "javascript",
            "name": "JavaScript"
          },
          {
            "icon": "typescript",
            "name": "TypeScript"
          },
          {
            "icon": "python",
            "name": "Python"
          },
          {
            "icon": "elixir",
            "name": "Elixir"
          },
          {
            "icon": "java",
            "name": "Java"
          },
          {
            "icon": "go",
            "name": "Go"
          },
          {
            "icon": "sqlite",
            "name": "SQLite"
          },
          {
            "icon": "postgresql",
            "name": "PostgreSQL"
          },
          {
            "icon": "mysql",
            "name": "MySQL"
          },
          {
            "icon": "mariadb",
            "name": "MariaDB"
          }
        ]
      },
      {
        "title": "Frameworks & Practices",
        "skills": [
          {
            "icon": "react",
            "name": "React"
          },
          {
            "icon": "redux",
            "name": "Redux"
          },
          {
            "icon": "phoenix",
            "name": "Phoenix"
          },
          {
            "icon": "ecto",
            "name": "Ecto"
          },
          {
            "icon": "commanded",
            "name": "Commanded"
          },
          {
            "icon": "spring_boot",
            "name": "Spring Boot"
          },
          {
            "icon": "storybook",
            "name": "Storybook"
          },
          {
            "icon": "jest",
            "name": "Jest"
          },
          {
            "icon": "cypress",
            "name": "Cypress"
          },
          {
            "icon": "open_source",
            "name": "Open Source Development"
          },
          {
            "icon": "antora",
            "name": "Antora"
          },
          {
            "icon": "docs_as_code",
            "name": "Docs as Code"
          },
          {
            "icon": "tdd",
            "name": "Test-Driven Development"
          },
          {
            "icon": "agile_scrum",
            "name": "Agile/Scrum"
          }
        ]
      }
    ]
  },
  "blog": {
    "title": "Blog",
    "overview": "Just a way to collect my ideas...",
    "missingPostMessage": "This blog post could not be found.",
    "backToPostsLabel": "Back to all posts",
    "readArticleLabel": "Read article",
    "emptyState": "No blog posts found. Add a post folder with `index.adoc` in `content/blog/` and run the blog sync script."
  },
  "cv": {
    "file": "/cv/Eugen_Maksymenko_CV.pdf",
    "downloadFileName": "Eugen_Maksymenko_CV.pdf",
    "loadingLabel": "Loading CV...",
    "previewUnavailableMessage": "The PDF preview is not available in this browser.",
    "downloadLabel": "Download CV",
    "pageLabel": "Page"
  },
  "contact": {
    "label": "Contact",
    "emailHref": "mailto:eugen.maksymenko@gmx.de",
    "emailLabel": "eugen.maksymenko[at]gmx.de"
  },
  "legalLinks": [
    {
      "title": "Imprint",
      "link": "/impressum"
    },
    {
      "title": "Privacy",
      "link": "/datenschutz"
    }
  ],
  "footer": {
    "socialLabel": "Links"
  },
  "socialLinks": [
    {
      "title": "GitHub",
      "link": "https://github.com/EMaksy",
      "icon": "github"
    },
    {
      "title": "LinkedIn",
      "link": "https://www.linkedin.com/in/eugen-maksymenko/",
      "icon": "linkedin"
    },
    {
      "title": "Xing",
      "link": "https://www.xing.com/profile/Eugen_Maksymenko/cv",
      "icon": "xing"
    }
  ],
  "pages": {
    "datenschutz": {
      "title": "Privacy",
      "intro": "Diese Datenschutzhinweise informieren ueber die Verarbeitung personenbezogener Daten beim Besuch dieser Website.",
      "notice": "Diese Website verwendet nach aktuellem Stand keine einwilligungspflichtigen Analyse-, Marketing- oder Tracking-Dienste. Die Inhalte unter www.emaksy.com werden ueber Microsoft Azure ausgeliefert; eine etwaige Domainverwaltung oder rein serverseitige HTTP-Weiterleitung ueber STRATO aendert nichts daran, dass Azure der Hosting-Anbieter der eigentlichen Website ist.",
      "controllerLabel": "Verantwortlicher",
      "controllerName": "Eugen Maksymenko",
      "controllerAddressLines": [
        "Am Stadtpark 25",
        "90409 Nürnberg",
        "Deutschland"
      ],
      "controllerEmailLabel": "E-Mail",
      "recipientsLabel": "Empfaenger",
      "recipientsParagraphs": [
        "Fuer das Hosting und die technische Bereitstellung dieser Website nutze ich Microsoft Azure Static Web Apps. Microsoft verarbeitet in diesem Zusammenhang Daten als Hosting- und Infrastrukturdienstleister.",
        "Die Domain dieser Website kann ueber STRATO verwaltet werden. Soweit STRATO fuer Domainregistrierung, DNS-Aufloesung oder eine rein serverseitige HTTP-Weiterleitung eingesetzt wird, verarbeitet STRATO dabei die jeweils technisch erforderlichen Verbindungsdaten."
      ],
      "hostingLabel": "Hosting und Server-Logfiles",
      "hostingParagraphs": [
        "Diese Website wird als Azure Static Web App bereitgestellt. Beim Aufruf der Website koennen technisch erforderliche Verbindungs- und Server-Logdaten verarbeitet werden, insbesondere IP-Adresse, Datum und Uhrzeit des Abrufs, angeforderte Inhalte sowie Angaben zum verwendeten Browser und Betriebssystem.",
        "Die Verarbeitung erfolgt zur technischen Bereitstellung der Website, zur Gewaehrleistung von Stabilitaet und Sicherheit sowie zur Fehleranalyse.",
        "STRATO ist, soweit eingesetzt, lediglich fuer Domainverwaltung, DNS oder eine vorgeschaltete rein serverseitige HTTP-Weiterleitung relevant und nicht fuer das Hosting der eigentlichen Website-Inhalte.",
        "Beim Aufruf der Domain emaksy.com ohne www kann zunaechst eine rein serverseitige HTTP-Weiterleitung auf https://www.emaksy.com ueber den Domain- oder Weiterleitungsdienst erfolgen. Dabei koennen die fuer diese Weiterleitung erforderlichen Verbindungsdaten verarbeitet werden."
      ],
      "hostingLegalBasisLabel": "Rechtsgrundlage",
      "hostingLegalBasis": "Art. 6 Abs. 1 lit. f DSGVO.",
      "hostingRetentionLabel": "Speicherdauer",
      "hostingRetention": "Ich speichere selbst keine gesonderten Besucher-Logfiles. Soweit beim Hosting-Anbieter technische Protokolle anfallen, werden sie nur solange aufbewahrt, wie dies fuer Bereitstellung, IT-Sicherheit und Stoerungsanalyse erforderlich ist. Werden zusaetzliche Azure-Monitor- oder Log-Analytics-Protokolle aktiviert, gelten dort nach Microsoft konfigurierbare Aufbewahrungsfristen mit Standardwerten ab 30 Tagen; Azure Activity Logs werden nach Microsoft 90 Tage vorgehalten.",
      "transfersLabel": "Drittlandtransfer",
      "transfersParagraphs": [
        "Es kann nicht ausgeschlossen werden, dass im Rahmen der Nutzung von Microsoft-Diensten personenbezogene Daten auch in Staaten ausserhalb der EU oder des EWR verarbeitet werden.",
        "Microsoft gibt an, fuer geeignete Garantien nach Art. 46 DSGVO insbesondere die EU-Standardvertragsklauseln zu verwenden."
      ],
      "emailContactLabel": "Kontaktaufnahme per E-Mail",
      "emailContactParagraphs": [
        "Wenn Sie per E-Mail Kontakt aufnehmen, werden die mit Ihrer Anfrage uebermittelten Daten zur Bearbeitung der Anfrage verarbeitet.",
        "Die Verarbeitung erfolgt zur Kommunikation mit Ihnen und auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO; bei einer vertraglichen Anbahnung kann zusaetzlich Art. 6 Abs. 1 lit. b DSGVO einschlaegig sein."
      ],
      "externalLinksLabel": "Externe Links",
      "externalLinksParagraphs": [
        "Diese Website enthaelt Links zu externen Profilen und Websites, zum Beispiel zu GitHub, LinkedIn oder Xing.",
        "Beim Anklicken eines solchen Links verlassen Sie diese Website. Fuer die Verarbeitung personenbezogener Daten auf den verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich."
      ],
      "cookiesLabel": "Cookies, lokale Speicher und Einwilligungsmanagement",
      "cookiesParagraphs": [
        "Diese Website verwendet nach aktuellem Stand keine Cookies oder aehnlichen Technologien zu Analyse-, Marketing- oder Trackingzwecken und bindet keine einwilligungspflichtigen Drittanbieter-Dienste oder externen Medien mit vorheriger Einwilligungspflicht ein.",
        "Ebenso werden durch diese Website keine nutzerbezogenen Informationen im localStorage oder sessionStorage gespeichert.",
        "Ein Consent-Tool wird derzeit nicht eingesetzt, weil auf dieser Website nach aktuellem Stand keine einwilligungspflichtigen Cookies oder vergleichbaren Technologien aktiviert werden. Sollten spaeter optionale Dienste eingebunden werden, wird vor deren Aktivierung ein entsprechendes Einwilligungsmanagement umgesetzt."
      ],
      "rightsLabel": "Ihre Rechte",
      "rightsItems": [
        "Auskunft ueber die zu Ihrer Person verarbeiteten Daten",
        "Berichtigung unrichtiger Daten",
        "Loeschung oder Einschraenkung der Verarbeitung, soweit die gesetzlichen Voraussetzungen vorliegen",
        "Datenuebertragbarkeit, soweit die gesetzlichen Voraussetzungen vorliegen",
        "Widerspruch gegen eine Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO"
      ],
      "complaintLabel": "Beschwerderecht",
      "complaintParagraphs": [
        "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehoerde ueber die Verarbeitung Ihrer personenbezogenen Daten zu beschweren."
      ]
    },
    "impressum": {
      "title": "Imprint",
      "intro": "Angaben gemaess § 5 DDG.",
      "addressLabel": "Anschrift",
      "addressName": "Eugen Maksymenko",
      "addressLines": [
        "Am Stadtpark 25",
        "90409 Nürnberg",
        "Deutschland"
      ],
      "contactLabel": "Kontakt",
      "emailLabel": "E-Mail",
      "responsibleLabel": "Verantwortlich fuer den Inhalt gemaess § 18 Abs. 2 MStV",
      "responsibleName": "Eugen Maksymenko",
      "responsibleAddressLines": [
        "Am Stadtpark 25",
        "90409 Nürnberg",
        "Deutschland"
      ]
    },
    "notFound": {
      "eyebrow": "Error",
      "title": "Page not found",
      "description": "The page you requested does not exist or the link is no longer valid.",
      "backHomeLabel": "Back to home"
    }
  }
};

export default siteContent;
